import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 px-6 py-14 lg:px-16"
    >
      <div className="flex flex-wrap items-start justify-between gap-10">
        <div>
          <p className="flex items-center gap-3">
            <img
              src="/assets/logo-icon.png"
              alt="GEKKOFUEL logo"
              className="h-10 w-10 rounded-full border border-white/15 object-cover"
            />
            <span className="font-sans text-lg font-bold tracking-[0.22em] text-cream">
              GEKKOFUEL
            </span>
          </p>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-sage/70">
            Slip din vilde side fri
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-sage">
            Kronegekkoer, reptilpleje og håndlavede terrarier — fra vores hjem i
            Danmark.
          </p>
        </div>
        <div className="flex gap-16">
          <div className="space-y-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-pale/70">
              Udforsk
            </p>
            {[
              ["Correlophus ciliatus", "#morphs"],
              ["Butik", "#shop"],
              ["Terrarier", "#terrariums"],
            ].map(([label, hash]) => (
              <button
                key={hash}
                data-testid={`footer-link-${label.toLowerCase()}`}
                onClick={() => scrollToSection(hash)}
                className="block text-sm text-sage transition-colors hover:text-cream"
              >
                {label}
              </button>
            ))}
            <Link
              data-testid="footer-link-linjeavl"
              to="/linjeavl"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              Linjeavl
            </Link>
            <Link
              data-testid="footer-link-kontakt"
              to="/kontakt"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              Kontakt
            </Link>
            <Link
              data-testid="footer-link-plejeguide"
              to="/plejeguide"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              Plejeguide
            </Link>
            <Link
              data-testid="footer-link-messekalender"
              to="/messekalender"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              Messekalender
            </Link>
            <Link
              data-testid="footer-link-handelsbetingelser"
              to="/handelsbetingelser"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              Handelsbetingelser
            </Link>
          </div>
          <div className="space-y-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-pale/70">
              Webshop
            </p>
            <a
              data-testid="footer-webshop-link"
              href="https://gekkofuel.dk"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm text-sage transition-colors hover:text-cream"
            >
              gekkofuel.dk
            </a>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-sage/60">
          © 2026 GEKKOFUEL · Frederik &amp; Sesilie
        </p>
        <p
          data-testid="footer-cvr"
          className="font-mono text-[10px] uppercase tracking-[0.2em] text-sage/60"
        >
          Gekkofuel | CVR: 43625217
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-sage/60">
          Levende dyr sælges som privat hobbyopdræt — ikke via virksomheden
        </p>
      </div>
    </footer>
  );
}
